
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../state';
import { UserInfo } from '../../../../../common/framework/model/UserInfo';
import { getUser, putUser } from '../../../client/users';
import UserGroups from './UserGroups.vue';
import SelectField from '../../../fields/SelectField.vue';
import PhoneField from '../../../fields/PhoneField.vue';
import TextField from '../../../fields/TextField.vue';
import EmailField from '../../../fields/EmailField.vue';
import SwitchField from '../../../fields/SwitchField.vue';
import UserRoles from './UserRoles.vue';
import { successToast } from '../../../../application/service/toast_service';

@Component({
    components: {
        UserRoles,
        SwitchField,
        SelectField,
        PhoneField,
        TextField,
        EmailField,
        UserGroups,
        ValidationObserver,
    },
})
export default class EditUser extends Vue {
    @Prop(String) public readonly id!: string;

    $refs!: {
        userGroups: UserGroups;
        userRoles: UserRoles;
    };

    shared = sharedState;
    local = {
        localeOptions: [
            { id: 'fi', label: 'FI' },
            { id: 'en', label: 'EN' },
        ],
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        locale: '',
        locked: false,
    };

    public async mounted() {
        const userId = this.$props.id;
        const user = await getUser(userId);

        this.local.firstName = user.firstName;
        this.local.lastName = user.lastName;
        this.local.email = user.email;
        this.local.phone = user.phone;
        this.local.locale = user.locale as any as string;
        this.local.locked = !!user.locked;
    }

    public async save() {
        await putUser(
            this.id,
            new UserInfo(
                this.local.firstName,
                this.local.lastName,
                this.local.email,
                this.local.phone,
                this.local.locale,
                this.local.locked,
            ),
        );
        (this.$refs.userGroups as any).save();
        (this.$refs.userRoles as any).save();

        await this.$router.push('/users');

        successToast(this, 'message.userSaved');
    }

    public back() {
        this.$router.go(-1);
    }
}
